import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { ENTITY_TYPES } from '@sales-center/common'
import { selectMapLinkClickedContactLocation } from '@user/store/map'
import { saveGeneralPreferencesBatch } from '@user/store/userPreferences/userPreferencesGeneral'
import { IUserPreferenceGeneralListItemType } from '@user/store/userPreferences/userPreferencesGeneral/typings'
import { useAppDispatch } from '@user/store/hooks'
import { userGeneralPreferencesList } from '@user/store/userPreferences/userPreferencesGeneral'
import { selectCurrentUser } from '@user/store/authorization'
import { logger } from '@user/utils/logger'

type UseFilterPreferencesProps = {
  open: boolean
}

export function useFilterPreferences({ open }: UseFilterPreferencesProps) {
  const dispatch = useAppDispatch()
  const mapLinkClickedContactLocation = useSelector(
    selectMapLinkClickedContactLocation,
  )
  const userGeneralPreferences = useSelector(userGeneralPreferencesList)
  const currentUser = useSelector(selectCurrentUser)

  useEffect(() => {
    if (mapLinkClickedContactLocation && open) {
      logger.log({ mapLinkClickedContactLocation })

      // Get current filter preferences
      const mapViewFilteredEntityTypesPreference = userGeneralPreferences?.find(
        (row) =>
          row?.type ===
          IUserPreferenceGeneralListItemType.MapViewFilteredEntityTypes,
      )

      const filteredRecordsStringValue =
        mapViewFilteredEntityTypesPreference?.value ??
        'draftlead_lead_opportunity'
      const selectedTypes = filteredRecordsStringValue
        .split('_')
        .filter(Boolean)

      // Map entity type string to filter keyF
      const entityTypeToFilterKey = (entityType: string): string => {
        switch (entityType) {
          case ENTITY_TYPES.DraftLead:
          case 'DRAFTLEAD':
            return 'draftlead'
          case ENTITY_TYPES.Lead:
          case 'LEAD':
            return 'lead'
          case ENTITY_TYPES.Opportunity:
          case 'OPPORTUNITY':
            return 'opportunity'
          default:
            return ''
        }
      }

      const clickedEntityFilterKey = entityTypeToFilterKey(
        mapLinkClickedContactLocation.entityType,
      )

      const isEntityTypeSelected = selectedTypes.includes(
        clickedEntityFilterKey,
      )
      const isMyRecord =
        mapLinkClickedContactLocation?.assigneeId === currentUser?.userId

      const mapViewFilteredMyRecordsPreference = userGeneralPreferences?.find(
        (row) =>
          row?.type ===
          IUserPreferenceGeneralListItemType.MapViewFilteredMyRecords,
      )

      const isMyRecordsFilterActive =
        mapViewFilteredMyRecordsPreference?.value === 'true'

      const needsUpdate =
        !isEntityTypeSelected || isMyRecord !== isMyRecordsFilterActive

      if (needsUpdate) {
        dispatch(
          saveGeneralPreferencesBatch([
            {
              type: IUserPreferenceGeneralListItemType.MapViewFilteredMyRecords,
              value: isMyRecord ? 'true' : 'false',
            },
            {
              type: IUserPreferenceGeneralListItemType.MapViewFilteredEntityTypes,
              value: 'draftlead_lead_opportunity',
            },
          ]),
        )
      }
    }
  }, [
    mapLinkClickedContactLocation,
    open,
    dispatch,
    userGeneralPreferences,
    currentUser,
  ])
}
